//@flow

export const maxConsumptionStrom = 200000;
export const maxConsumptionGas = 1500000;

export const maxConsumptionB2B = 20000000;
